import module from './index'

let moduleName = 'module->' + module.info.name;
const routes = [
    {
        path: module.info.name,
        name: moduleName,
        component: () => import('./View.vue'),
        children: [
            {
                path: 'create',
                name: moduleName + '->create',
                component: () => import('./create/View'),
            },
            {
                path: 'allow-ips',
                name: moduleName + '->server-ufw-commands',
                component: () => import('./server-ufw-command/View'),
            },
            {
                path: 'voip-clean-operations',
                name: moduleName + '->voip-clean-operations',
                component: () => import('./voip-clean-operations/View'),
            },
            {
                path: 'list',
                name: moduleName + '->list',
                component: () => import('./list/View'),
                children: [
                    {
                        path: ':listPage',
                        name: moduleName + '->list->page',
                        component: () => import('./list/page/View'),
                    }
                ]
            },
            {
                path: ':entityTitle',
                name: moduleName + '->view',
                component: () => import('./view/View.vue'),
            }
        ]
    }
];

export default routes
